/* eslint-disable */
export default {
  unmute: '取消靜音',
  mute: '靜音',
  keypad: '撥號盤',
  hold: '保留',
  onHold: '保留',
  park: '寄存',
  stopRecord: '停止',
  record: '錄製',
  add: '新增',
  transfer: '轉接',
  flip: '切換',
  more: '通話動作',
  mergeToConference: '合併',
  end: '結束',
  completeTransfer: '完成\n轉接',
} as const;

// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"park"@#@ @source: @#@"Park"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"more"@#@ @source: @#@"Call Actions"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete\nTransfer"@#@
